import { render } from "./BaseLoader.vue?vue&type=template&id=395d0746&scoped=true"
const script = {}

import "./BaseLoader.vue?vue&type=style&index=0&id=395d0746&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395d0746"]])

export default __exports__